export const rules = {
	// Card titles
	"rules.card.rules.title": "Règles",
	"rules.card.pointsAllocation.title": "Attribution des points",
	"rules.card.rulesContinued.title": "Règles (suite)",
	"rules.card.weeklyPrizes.title": "Structure des prix hebdomadaires",

	// Main rules content
	"rules.intro":
		'Tous les termes en majuscules utilisés dans ces règles (les <strong>"Règles"</strong>) porteront la définition qui leur est attribuée dans les conditions générales (les <strong>"Conditions générales"</strong>).',

	"rules.temporary_notice":
		"Veuillez noter que les gagnants de prix pendant la période du 19 décembre 2025 au 2 janvier 2026 recevront leurs prix dans les 7 (sept) jours à partir du 6 janvier 2026",

	"rules.rule1":
		"Les participants peuvent gagner des points en prédisant correctement le score de chacun des cinq (5) matchs chaque semaine/tour (selon le cas), pertinents à la compétition sportive à laquelle le jeu Betway Scores BW ScorePredict se rapporte, par exemple <em>Premier League anglaise</em>, etc. La compétition Betway Scores BW Score Predict commencera le 11 mars 2025 et se terminera à la fin de la saison de football 2025/2026.",

	"rules.rule2.main":
		"Les participants peuvent gagner des points bonus supplémentaires en prédisant correctement ce qui suit dans chacun des cinq (5) matchs :",
	"rules.rule2.a": "Score final correct",
	"rules.rule2.b": "Vainqueur correct",
	"rules.rule2.c": "Buts à domicile corrects",
	"rules.rule2.d": "Buts à l'extérieur corrects",
	"rules.rule2.e": "Différence de buts correcte",

	"rules.rule3": "Chaque semaine/tour correspond aux tours de cette compétition sportive.",

	"rules.rule4": "Les points sont attribués comme suit pour chacune des prédictions correctes suivantes du participant chaque semaine/tour :",

	// Points allocation
	"rules.points.correctScore": "Score final correct",
	"rules.points.correctScoreValue": "50",
	"rules.points.correctWinner": "Vainqueur correct",
	"rules.points.correctWinnerValue": "5",
	"rules.points.homeGoals": "Buts à domicile corrects",
	"rules.points.homeGoalsValue": "5",
	"rules.points.awayGoals": "Buts à l'extérieur corrects",
	"rules.points.awayGoalsValue": "5",
	"rules.points.goalDifference": "Différence de buts correcte",
	"rules.points.goalDifferenceValue": "5",

	// Continued rules
	"rules.rule5":
		"Les participants peuvent apporter des modifications à leurs prédictions à tout moment, jusqu'à 15 minutes avant le coup d'envoi de chacun des matchs de la semaine/tour concerné.",

	"rules.rule6":
		"Tous les utilisateurs connectés de Betway Scores et/ou BW Scores sont éligibles pour jouer à Betway Scores BW ScorePredict, cependant seuls les participants avec un compte Betway vérifié, au moment où les prix doivent être attribués, sont éligibles pour gagner des prix. Les changements des résultats du match selon le point 2. ci-dessus qui surviennent après l'attribution des prix (par exemple annulation du résultat) ne seront pas considérés rétrospectivement.",

	"rules.rule7":
		"Le participant qualifié et éligible qui termine la saison en première place et possède un compte Betway sera le gagnant du Grand Prix de la saison et gagnera un voyage pour deux (2) personnes pour voir Arsenal jouer à Londres, incluant les vols (si nécessaire), l'hébergement (si nécessaire) et £500 d'argent de poche.",

	"rules.rule8":
		"Si le gagnant du Grand Prix de la saison ne peut pas voyager en raison de ne pas avoir un passeport valide et/ou un visa et/ou toute autre limitation, il recevra un prix de €5 000 de solde en espèces, ou l'équivalent approximatif en monnaie locale à la date de commencement de la compétition (soit £4 500, R100 000 ou GH₵ 60 000), dans son compte Betway à la fin de la compétition.",

	"rules.rule9":
		"Le gagnant du Grand Prix de la saison peut choisir de ne pas prendre l'expérience et plutôt accepter un prix de €5 000 de solde en espèces, ou l'équivalent approximatif en monnaie locale à la date de commencement de la compétition (soit £4 500, R100 000 ou GH₵ 60 000), dans son compte Betway.",

	"rules.rule10":
		'Les prix hebdomadaires seront attribués aux "Top 10" performeurs chaque semaine/tour qui ont un compte de paris Betway valide. Si un performeur du Top 10 n\'a pas de compte de paris Betway, il ne recevra pas de prix hebdomadaire.',

	"rules.rule11":
		"Les places hebdomadaires 1 à 10 gagneront les montants suivants de solde en espèces, selon leur région, dans leur compte Betway.",

	"rules.rule12":
		"Les prix hebdomadaires seront attribués dans les 7 (sept) jours suivant la finalisation des résultats de cette semaine et le Grand Prix sera attribué dans les 7 (sept) jours suivant la conclusion de la compétition Betway Scores BW Score Predict.",

	"rules.rule13":
		"En cas d'égalité pour les prix hebdomadaires, le solde en espèces pour cette position (et les positions pertinentes en dessous qui sont impactées par l'égalité) sera divisé équitablement entre les participants à égalité.",

	"rules.rule14":
		"En cas d'égalité pour le Grand Prix, un mécanisme de randomisation sera utilisé pour sélectionner seulement un des participants à égalité comme gagnant du Grand Prix.",

	// Weekly prize table data
	"rules.weeklyPrizes.position1.eur": "€150",
	"rules.weeklyPrizes.position1.gbp": "£150",
	"rules.weeklyPrizes.position1.zar": "R3000",
	"rules.weeklyPrizes.position1.ghs": "GH₵2000",

	"rules.weeklyPrizes.position2.eur": "€100",
	"rules.weeklyPrizes.position2.gbp": "£100",
	"rules.weeklyPrizes.position2.zar": "R2000",
	"rules.weeklyPrizes.position2.ghs": "GH₵1250",

	"rules.weeklyPrizes.position3.eur": "€75",
	"rules.weeklyPrizes.position3.gbp": "£75",
	"rules.weeklyPrizes.position3.zar": "R1500",
	"rules.weeklyPrizes.position3.ghs": "GH₵1000",

	"rules.weeklyPrizes.position4.eur": "€50",
	"rules.weeklyPrizes.position4.gbp": "£50",
	"rules.weeklyPrizes.position4.zar": "R1000",
	"rules.weeklyPrizes.position4.ghs": "GH₵600",

	"rules.weeklyPrizes.position5.eur": "€40",
	"rules.weeklyPrizes.position5.gbp": "£40",
	"rules.weeklyPrizes.position5.zar": "R800",
	"rules.weeklyPrizes.position5.ghs": "GH₵500",

	"rules.weeklyPrizes.position6.eur": "€30",
	"rules.weeklyPrizes.position6.gbp": "£30",
	"rules.weeklyPrizes.position6.zar": "R600",
	"rules.weeklyPrizes.position6.ghs": "GH₵400",

	"rules.weeklyPrizes.position7.eur": "€20",
	"rules.weeklyPrizes.position7.gbp": "£20",
	"rules.weeklyPrizes.position7.zar": "R400",
	"rules.weeklyPrizes.position7.ghs": "GH₵250",

	"rules.weeklyPrizes.position8.eur": "€15",
	"rules.weeklyPrizes.position8.gbp": "£15",
	"rules.weeklyPrizes.position8.zar": "R300",
	"rules.weeklyPrizes.position8.ghs": "GH₵200",

	"rules.weeklyPrizes.position9.eur": "€10",
	"rules.weeklyPrizes.position9.gbp": "£10",
	"rules.weeklyPrizes.position9.zar": "R200",
	"rules.weeklyPrizes.position9.ghs": "GH₵100",

	"rules.weeklyPrizes.position10.eur": "€10",
	"rules.weeklyPrizes.position10.gbp": "£10",
	"rules.weeklyPrizes.position10.zar": "R200",
	"rules.weeklyPrizes.position10.ghs": "GH₵100",

	// Table headers
	"rules.weeklyPrizes.header.position": "# Par tour",
	"rules.weeklyPrizes.header.eur": "EUR",
	"rules.weeklyPrizes.header.gbp": "GBP",
	"rules.weeklyPrizes.header.zar": "ZAR",
	"rules.weeklyPrizes.header.ghs": "GHS",
};
